import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	fetchError: {
		id: 'software-reports-cumulative-flow-diagram.fetch-error',
		defaultMessage: 'There was an error while fetching your report.',
		description: 'Message shown when the request to load the CFD report fails',
	},
	retryOnError: {
		id: 'software-reports-cumulative-flow-diagram.retry-on-error',
		defaultMessage: 'Retry',
		description: "Action message to retry fetching CFD report data when there's a failure",
	},
	emptyReportHeader: {
		id: 'software-reports-cumulative-flow-diagram.empty-report-header',
		defaultMessage: "You don't have enough data for this report.",
		description: 'Empty state header for the cumulative flow diagram report',
	},
	emptyReportDescription: {
		id: 'software-reports-cumulative-flow-diagram.empty-report-description',
		defaultMessage: 'Try creating issues and moving them through columns.',
		description: 'Empty state body for the cumulative flow diagram report',
	},
});

export default messages;
